/* eslint-disable import/prefer-default-export */
function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ]

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem)
  })
}

function getWalletItemSelected() {
  return localStorage.getItem('cm_wallet_item_selected')
}

function setWalletItemSelected(id) {
  localStorage.setItem('cm_wallet_item_selected', id)
}

function removeWalletItemSelected() {
  localStorage.removeItem('cm_wallet_item_selected')
}

export {
  detectMob,
  setWalletItemSelected,
  getWalletItemSelected,
  removeWalletItemSelected
}
